// extracted by mini-css-extract-plugin
export var addButton = "_5e-d";
export var bullets = "_5e-e";
export var compact = "_5e-2";
export var container = "_5e-j";
export var extendedWarrantyModal = "_5e-f";
export var learn = "_5e-l";
export var learnMore = "_5e-g";
export var offeringOption = "_5e-3";
export var offeringPrice = "_5e-8";
export var offeringSubtitle = "_5e-7";
export var offeringTitle = "_5e-6";
export var offeringsContainer = "_5e-0";
export var pdpTilesBackground = "_5e-n";
export var plan = "_5e-m";
export var regular = "_5e-1";
export var remove = "_5e-k";
export var seeDetailsIcon = "_5e-i";
export var seeDetailsLink = "_5e-h";
export var selectedOption = "_5e-4";
export var shieldIcon = "_5e-b";
export var shieldIconCompact = "_5e-c";
export var subtitle = "_5e-a";
export var title = "_5e-9";
export var unselectedOption = "_5e-5";